import React from 'react';
import '../../styles/RateCard.css';

const EventsBeHealth = () => {
    return (
        <section className="events-be-health-section py-5" id='eventos'>
            <div className="container">
                <div className="row gx-5 align-items-center">

                    {/* Columna Izquierda */}
                    <div className="col-md-6 bg-dark-teal text-white p-5 rounded-start" data-aos="fade-right" data-aos-delay="200">
                        <h2 className="title text-white text-capitalize">
                            Eventos<br /><span className="highlight-bg">BeHealth</span>
                        </h2>
                        <p className="mt-4">
                            En BeHealth diseñamos eventos que informan, educan y promueven hábitos saludables en la sociedad. 
                            Estos encuentros reúnen a expertos, pacientes, organizaciones y la comunidad, creando espacios para 
                            abordar temas relevantes de salud y fomentar una sociedad más consciente y responsable.
                        </p>
                        <ul className="mt-4 custom-bullets">
                            <li>Incrementan la concienciación sobre temas críticos de salud.</li>
                            <li>Conectan a tu marca con iniciativas de impacto social positivo.</li>
                            <li>Reúnen a audiencias diversas, incluyendo profesionales, pacientes y comunidades.</li>
                            <li>Generan contenido relevante para amplificación digital.</li>
                        </ul>
                        <div className="tab-label mt-4">Eventos</div>
                    </div>

                    {/* Columna Derecha */}
                    <div className="col-md-6 bg-light-green p-5 rounded-end position-relative" data-aos="fade-left" data-aos-delay="200">

                        <div className='d-flex justify-content-center'>
                            <div className='position-relative z-0'>
                                <h3 className="subtitle-rate-card fw-bold text-center">Tipos de eventos</h3>

                                <div className='position-absolute top-100 start-50 translate-middle'>
                                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#056059" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                                </div>
                            </div>
                        </div>
                        <div className='reach mt-3 rounded p-3'>
                            <h3 className='fw-bold text-center'>y ejemplos</h3>
                            <ul className="ps-3 mt-2 text-start">
                                <li className='mt-3'><span className='fw-bold'>Campañas de Prevención y Educación: </span>
                                Jornadas de vacunación, talleres de nutrición y campañas contra enfermedades cardiovasculares.</li>
                                <li className='mt-3'><span className='fw-bold'>Jornadas de Salud Comunitaria: </span>
                                Revisiones médicas gratuitas, ferias de salud y talleres de primeros auxilios.</li>
                                <li className='mt-3'><span className='fw-bold'>Congresos y Conferencias: </span>
                                Congresos de medicina, simposios sobre enfermedades raras y conferencias de salud mental.</li>
                                <li className='mt-3'><span className='fw-bold'>Eventos de Concienciación: </span>
                                Días mundiales de concienciación (cáncer, diabetes, Alzheimer) y campañas temáticas.</li>
                                <li className='mt-3'><span className='fw-bold'>Carreras Solidarias: </span>
                                Caminatas y maratones por causas de salud como la donación de órganos o la salud mental.</li>
                                <li className='mt-3'><span className='fw-bold'> Eventos Virtuales y Webinars: </span>
                                Charlas de expertos, seminarios online y transmisiones en vivo sobre prevención de enfermedades.</li>
                                <li className='mt-3'><span className='fw-bold'>Responsabilidad Social Corporativa: </span>
                                Campañas de donación de sangre, voluntariado en hospitales y jornadas de salud en comunidades vulnerables.</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default EventsBeHealth;
